import { environment } from 'src/environments/environment';

export interface RuntimePwaAuthConfig {
  enabled: boolean;
  username: string;
  password: string;
}

export interface RuntimeAppConfig {
  apiBaseUrl?: string;
  pwaAuth?: RuntimePwaAuthConfig;
}

declare global {
  interface Window {
    __BEBOP_RUNTIME_CONFIG__?: RuntimeAppConfig;
  }
}

function readRuntimeConfig(): RuntimeAppConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  const runtimeConfig = window.__BEBOP_RUNTIME_CONFIG__;
  return runtimeConfig && typeof runtimeConfig === 'object' ? runtimeConfig : {};
}

function normalizeString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function getRuntimeConfig(): RuntimeAppConfig {
  const runtimeConfig = readRuntimeConfig();
  const environmentConfig = environment as typeof environment & RuntimeAppConfig;

  return {
    apiBaseUrl: normalizeString(runtimeConfig.apiBaseUrl || environmentConfig.apiBaseUrl),
    pwaAuth: {
      enabled: Boolean(runtimeConfig.pwaAuth?.enabled),
      username: normalizeString(runtimeConfig.pwaAuth?.username),
      password: normalizeString(runtimeConfig.pwaAuth?.password),
    },
  };
}

export function getRuntimePwaAuthConfig(): RuntimePwaAuthConfig {
  const runtimeConfig = getRuntimeConfig();
  const config = runtimeConfig.pwaAuth ?? { enabled: false, username: '', password: '' };
  const username = normalizeString(config.username);
  const password = normalizeString(config.password);
  const hasCredentials = Boolean(username && password);

  return {
    enabled: Boolean(config.enabled && hasCredentials),
    username,
    password,
  };
}
